import { Component, inject } from '@angular/core';
import { AppInfoService } from '../../../services/app-info.service';

@Component({
  selector: 'app-information-banner',
  imports: [],
  templateUrl: './information-banner.component.html',
  styleUrl: './information-banner.component.scss',
})
export class InformationBannerComponent {

  private readonly informationService = inject(AppInfoService);
  readonly messages = this.informationService.messages;


}
